import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const problems = ['Te quedas sin gas a mitad del round y terminas sobreviviendo en lugar de atacar.', 'Sufres lesiones recurrentes en hombros, rodillas o lumbares que te alejan del tatami.', 'Sientes que no tienes una base de fuerza real y tus oponentes te dominan físicamente.', 'Tu falta de movilidad de cadera limita tu juego de guardia y transiciones.', 'No tienes una preparación física estructurada y solo improvisas rutinas de gimnasio.'];
export function Problems() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-zinc-950 border-y border-zinc-900" data-id="element-76">
      <div className="max-w-4xl mx-auto" data-id="element-77">
        <div className="text-center mb-12" data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-4" data-id="element-79">
            ¿Te suena familiar alguna de estas situaciones?
          </h2>
          <div className="w-24 h-1 bg-amber-400 mx-auto rounded-full" data-id="element-80" />
        </div>

        <div className="grid gap-4" data-id="element-81">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-5 rounded-xl bg-zinc-900/50 border border-zinc-800/50 hover:border-red-900/30 transition-colors" data-id="element-82">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-83" />
              <p className="text-zinc-300 text-lg" data-id="element-84">{problem}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}